// const HrApi = 'https://192.168.3.8:8000/api'
// const HrApi = 'https://192.168.3.232:8000/api'
// const HrApi = 'https://192.168.168.117:8000/api'
// module.exports.HrApi = "http://localhost:8000/api";
// module.exports.HrApi = 'http://192.168.3.7:7000/api'
// module.exports.HrApi = "https://store.projmantech.com/api";
module.exports.HrApi = "https://inventory.infotechitsolutionsbd.com/api";

// module.exports.imageApi = "http://localhost:8000";
// module.exports.imageApi = 'http://192.168.3.7:7000'
// module.exports.imageApi = "https://store.projmantech.com";
module.exports.imageApi = "https://inventory.infotechitsolutionsbd.com/";
